import createStyles from 'draft-js-custom-styles';

const { styles: inlineStylesMap, customStyleFn } = createStyles(['color', 'selected'], 'CUSTOM_', {});

export { inlineStylesMap, customStyleFn };
